module.exports = __webpack_public_path__ + "img/not-authorized.102aee6a.svg";